import axiosInstances from '@/helper/axiosInstances';
import qs from 'qs';

export default function customers() {
	const { axiosInstance } = axiosInstances();

	async function getCustomers(params, customerId = null) {
		const method = 'get';
		let url = `point-of-sale/customers/`;
		if (customerId) url += customerId

		const response = await axiosInstance({
			method,
			url,
			params,
		});
		return response;
	}
	async function getTopUpsCustomer(params) {
		const method = 'get';
		let url = `point-of-sale/orders/`;

		const response = await axiosInstance({
			method,
			url,
			params,
			paramsSerializer: (params) => {
				return qs.stringify(params, { arrayFormat: 'comma', encode: false});
			},
		});
		return response;
	}
	async function getDiscountCustomer(params) {
		const method = 'get';
		let url = `point-of-sale/discounts/get_by_customer/`;

		const response = await axiosInstance({
			method,
			url,
			params
		});
		return response;
	}
	async function getTopUpOrders(params, orderId = null) {
		const method = 'get';
		let url = `point-of-sale/topup_requests/`;
		if (orderId) url += orderId;

		const response = await axiosInstance({
			method,
			url,
			params,
			paramsSerializer: (params) => {
				return qs.stringify(params, { arrayFormat: 'comma', encode: false});
			},
		});
		return response;
	}

	return { getCustomers, getTopUpsCustomer, getDiscountCustomer, getTopUpOrders };
}
